import { Navigate } from "react-router-dom";
import { useUser } from "../context/userContext";

// Keeps auth pages (login, signup, verify-email) off-limits to a user who's
// already logged in — bounce them to "/", which HomeRedirect resolves to
// wherever they actually belong.
export default function GuestRoute({ children }) {
  const { isAuthenticated, loading } = useUser();

  if (loading) return null;
  if (isAuthenticated) return <Navigate to="/" replace />;

  return children;
}
